<section class="container pt-2">
  <div class="row">
    <div class="col-md-8 offset-lg-1 pb-5 mb-2 mb-lg-4 pt-md-5 mt-n3 mt-md-0 text-center">
      <h3>Access Denied</h3>
      <p>If you require assistance, please contact <a href="mailto:support@appliedbiox.com">support&#64;appliedbiox.com</a>. </p>
    </div>
  </div>
</section>
